module.exports = __webpack_public_path__ + "static/media/dictionary-employees.2a65c1d1.svg";